<template>
  <v-dialog v-model="localValue" max-width="400" lazy>
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>{{ $t('fields.users.lastAccess') }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="localValue = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.users.lastAccess') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ formatDate(localLastAccess.accessAt) }}
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.type') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ localLastAccess.type }}
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.global.coordinates') }}
          </v-flex>
          <v-flex xs12 md6>
            <span>{{ localLastAccess.lat }}</span>
            <span v-if="localLastAccess.lon">, {{ localLastAccess.lon }}</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="localValue = false" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'DialogLastAccess',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    lastAccess: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    localLastAccess() {
      if (!this.lastAccess.length) return {}
      let lastAccess = this.lastAccess.slice()
      lastAccess.sort((a, b) => new Date(b.accessAt) - new Date(b.accessAt))

      return lastAccess[0]
    },
  },
  methods: {
    formatDate(date) {
      return formatDate(date, true)
    },
  },
}
</script>
